interface InstagramIconProps {
  stroke?: string
}

const InstagramIcon = ({ stroke = '#181919' }: InstagramIconProps) => (
  <svg
    width="25"
    height="25"
    viewBox="0 0 25 25"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect x="0.55" y="0.55" width="25" height="25" rx="5" fill="white" />
    <path
      d="M17.1765 2.5H7.10572C4.32474 2.5 2.07031 4.73861 2.07031 7.5V17.5C2.07031 20.2615 4.32474 22.5 7.10572 22.5H17.1765C19.9575 22.5 22.2119 20.2615 22.2119 17.5V7.5C22.2119 4.73861 19.9575 2.5 17.1765 2.5Z"
      stroke={stroke}
      strokeWidth="1.03"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M16.1695 11.8699C16.2937 12.7022 16.1506 13.5522 15.7603 14.299C15.3701 15.0457 14.7526 15.6513 13.9958 16.0296C13.239 16.4079 12.3813 16.5395 11.5447 16.4059C10.7082 16.2722 9.93538 15.88 9.33625 15.2851C8.73711 14.6902 8.34215 13.9228 8.20754 13.0921C8.07293 12.2615 8.20552 11.4098 8.58646 10.6583C8.9674 9.90679 9.57729 9.29368 10.3294 8.90618C11.0815 8.51868 11.9375 8.37652 12.7756 8.49994C13.6305 8.62582 14.422 9.0214 15.0332 9.62824C15.6443 10.2351 16.0427 11.021 16.1695 11.8699Z"
      stroke={stroke}
      strokeWidth="1.03"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M17.6801 7H17.6901"
      stroke={stroke}
      strokeWidth="1.03"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)

export default InstagramIcon
